import { render, staticRenderFns } from "./HowAdd.vue?vue&type=template&id=0f2b3b52&scoped=true"
import script from "./HowAdd.vue?vue&type=script&lang=js"
export * from "./HowAdd.vue?vue&type=script&lang=js"
import style0 from "./HowAdd.vue?vue&type=style&index=0&id=0f2b3b52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2b3b52",
  null
  
)

export default component.exports